import axios from 'axios';

// const COGNITO_AUTH_API = process.env.REACT_APP_AUTH_API_URL;
// const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_AUTH_CLIENT_ID;
// const COGNITO_CLIENT_SECRET = process.env.REACT_APP_COGNITO_AUTH_CLIENT_SECRET;

const axiosApiInstance = axios.create();

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    const access_token = sessionStorage.getItem('token');
    config.headers['Authorization'] = `Bearer ${access_token}`;
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

const axiosApiInstanceFormData = axios.create();

axiosApiInstanceFormData.interceptors.request.use(
  async (config) => {
    const access_token = sessionStorage.getItem('token');
    config.headers['Authorization'] = `Bearer ${access_token}`;
    config.headers['Content-Type'] = 'multipart/form-data';
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);
// Response interceptor for API calls
// axiosApiInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async function (error) {
//     const originalRequest = error.config;
//     if (error.response.status === 403 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       // TODO
//       /*       const access_token = await getAccessToken();
//       axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`; */
//       return axiosApiInstance(originalRequest);
//     }
//     return Promise.reject(error);
//   },
// );

const getAccessToken = () => {
  //   let authString = `${COGNITO_CLIENT_ID}:${COGNITO_CLIENT_SECRET}`;
  //   console.log('auth string', authString);
  //   let buffer = new Buffer(authString);
  //   let base64Auth = buffer.toString('base64');
  //   const authRequestConfig = {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       Authorization: `Basic ${base64Auth}`,
  //     },
  //   };
  //   const requestBody = 'grant_type=client_credentials';
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .post(COGNITO_AUTH_API, requestBody, authRequestConfig)
  //       .then((response) => {
  //         const { access_token } = response.data;
  //         sessionStorage.setItem('token', access_token);
  //         resolve(access_token);
  //       })
  //       .catch((error) => {
  //         console.log('error requesting token: ', error);
  //         reject(null);
  //       });
  //   });
};

export { axiosApiInstance, axiosApiInstanceFormData, getAccessToken };
